import './AuthenticationForm.scss';

import React, { useState } from 'react';
import { useFormik } from 'formik';

import yup from 'src/utils/yup';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Button from 'src/component/UI/Button';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'src/i18n';

export default function PasswordResetForm (props) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: values => {
      setIsSubmitting(true);
      props.handlePasswordResetRequest(values.email);
    },
    validationSchema: () => {
      return yup.object().shape({
        email: yup.string()
          .email(t('auth.invalidEmail'))
          .required(t('auth.emailRequired'))
      });
    },
  });

  const renderResetForm = (
    <form className='auth-form' onSubmit={formik.handleSubmit}>
      <TextField
        id='email'
        type='email'
        label={t('auth.email')}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
        error={formik.errors.email && formik.touched.email}
        helperText={formik.touched.email && formik.errors.email}
        variant='outlined'
        fullWidth
        InputLabelProps={{ shrink: false }}
      />

      <div className='auth-form-buttons'>
        <Button type='submit' cta background>{t('auth.sendPasswordResetEmail')}</Button>
        <NavLink className='float-right' exact to='/login'>{t('common.back')}</NavLink>
      </div>

    </form>
  );

  const renderConfirmation = (
    <div className='confirmation'>
      <h2>{t('auth.checkInbox')}</h2>
      <h3>{t('auth.passwordResetSent')}</h3>
      <p>{t('auth.checkEmailAndTryAgain')}</p>
    </div>
  );

  return isSubmitting ? renderConfirmation : renderResetForm;
}

PasswordResetForm.propTypes = {
  handlePasswordResetRequest: PropTypes.func.isRequired
};

PasswordResetForm.defaultProps = {
};
